"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cache = void 0;
var cache = {
    authorizationToken: null,
    customerId: null
};
exports.cache = cache;
//# sourceMappingURL=client-cache.js.map